// Module
var code = `<div class="oe-parameters-positionSizing" {{^dp.positionSizingIsVisible}}style="display:none;" {{/}}>
    <div class="oe-parameters-positionSizing-numeric">
        {{#if showLabel}}
        <terceraLabel text="{{label}}" visible="{{dp.positionSizingIsVisible}}" />
        {{/if}}

        <div class="oe-parameters-positionSizing-numeric-right">
            <terceraNumeric visible="{{dp.positionSizingIsVisible}}"
                            decimalPrecision="{{dp.decimalPlaces}}"
                            minValue="{{dp.minimalValue}}"
                            maxValue="{{dp.maximalValue}}"
                            step="{{dp.increment}}"
                            value="{{dp.value}}"
                            enabled="{{dp.enabled}}"
                            customError="{{dp.error}}"
                            Intervals="{{dp.Intervals}}"
                            tooltip="{{.accountRiskTT}}"
                            tradingNumeric="true"
                            name="PositionSizingNumeric" />

            <terceraButton visible="{{dp.positionSizingIsVisible}}"
                           terceraButtonStyle="js-button-fixedOrPercentMode"
                           text="{{.riskModeBtnText}}"
                           enabled="{{.enabled}}"
                           checked="{{fixedOrPercentMenuIsOpen}}"
                           on-btnMouseDown="fixedOrPercentageBtnMouseDown"
                           on-btnClick="fixedOrPercentageBtnClick" />
        </div>
    </div>

    <div class="oe-parameters-positionSizing-labels">
        <terceraLabel text="{{.riskLabel}}" visible="{{dp.positionSizingIsVisible}}" />

        <div class="oe-parameters-positionSizing-labels-right">
            <terceraLabel text="{{OtherRisk}}" visible="{{dp.positionSizingIsVisible}}" />
        </div>
    </div>
</div>`;
// Exports
export default code;